export class ModelMenu{
    public presetMenu: any[] = [
        { label: 'Página Inicial', icon: 'home', routerLink: ['sistema/', 'modulos'] },
        {
          label: 'Usuários', icon: 'person',
          items: [
            { label: 'Externo CRC', icon: 'list', routerLink: ['usuarios', 'usuario-externo'] },
            { label: 'Interno CFC', icon: 'list', routerLink: ['usuarios', 'usuario-interno'] },
            { label: 'Alterar Senha', icon: 'fingerprint', routerLink: ['usuarios/', 'alterar-senha'] },
            { label: 'Lotação Usuário', icon: 'list', routerLink: ['usuarios', 'lotacao-usuario'] }
          ]
        },
        {
          label: 'Sistema', icon: 'settings',
          items: [
            { label: 'Gerenciar Sistema', icon: 'settings', routerLink: ['sistema/', 'sistemas'] },
            { label: 'Perfil', icon: 'security', routerLink: ['sistema/', 'perfil'] },
            { label: 'Ações', icon: 'settings', routerLink: ['sistema/', 'acoes'] },
            { label: 'Funcionalidades', icon: 'settings', routerLink: ['sistema/', 'funcionalidade'] },
            { label: 'Funcionalidade Perfil', icon: 'settings', routerLink: ['sistema/', 'funcionalidade-perfil'] },
            { label: 'Gerenciar Lotação', icon: 'list', routerLink: ['sistema/', 'lotacao'] },
            { label: 'Central de Notificações', icon: 'notifications', routerLink: ['sistema/', 'central-notificacao'] },
            { label: 'Trilha de Auditoria', icon: 'zoom_in', routerLink: ['sistema/', 'trilha-auditoria'] }
          ]
        },
        {
          label: 'Permissões', icon: 'settings',
          items: [
            { label: 'Minhas Permissões', icon: 'lock_open', routerLink: ['permissoes/', 'minhas-permissoes'] },
            { label: 'Gerenciar Permissões', icon: 'security', routerLink: ['permissoes/', 'gerenciar-permissoes'] },
            { label: 'Permissões Pendentes', icon: 'thumbs_up_down', routerLink: ['permissoes/', 'permissoes-pendentes'] }
          ]
        },
      ];
}


// WEBPACK FOOTER //
// ./src/app/entity/menu.model.ts